export const product = {
  Fwd: 1,
  Spot: 2,
  Collar: 3,
  Avg: 4,
  Future: 5,
  FxSwap: 6,
  Exotic: 7,
  Window: 8,
  Call: 9,
  Put: 10,
}

export const groupCategoryType = {
  DropDownList: 1,
  TextBox: 2,
}
